import type { LeverFormField } from './types.js'

export const ALL_LEVER_FIELDS_TOUCHED: Record<LeverFormField, boolean> = {
	leverId: true,
	defaultValue: true
}
